import React from "react";
import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./screens/Home";
import About from "./screens/About";
import Login from "./screens/Login";
import Gallery from "./screens/Gallery";
import Videos from "./screens/Videos";
import SinglePost from "./screens/SinglePost";
import LatestPosts from "./screens/LatestPosts";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Signup from "./screens/Signup";
import AdminDashboard from "./screens/AdminDashboard";
import Messages from "./screens/Messages";
import UserInfo from "./screens/UserInfo";
import CreateContent from "./screens/CreateContent";
import PostReview from "./screens/PostReview";
import Resources from "./screens/Resources"
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import EditPost from "./screens/EditPost";
import Analytics from "./screens/Analytics";
import VideoReview from "./screens/VideoReview";
import Search from "./screens/Search";
import ClearStorageOnClose from "./components/ClearStorage/ClearStorage";
import GlobalTTS from "./components/TTSWrapper/TTSWrapper";
import ChatbotBubble from "./components/ChatBot/chatbotBubble";

export default function App() {
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    let sessionId = localStorage.getItem("sessionId");

    // Initialize TTS
    if (localStorage.getItem("TTS") === null) {
      localStorage.setItem("TTS", "false");
      console.log("Initialized TTS in localStorage");
    }

    // Create new sessionId if none exists (for guests)
    if (!sessionId) {
      sessionId =
        (crypto.randomUUID && crypto.randomUUID()) ||
        Math.random().toString(36).substring(2);
      localStorage.setItem("sessionId", sessionId);
    }

    fetch(`${process.env.REACT_APP_API_URL}/analytics/track-visit`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        sessionId,
        userId: user?.userId || null,
      }),
    });
  }, []);

  return (
    <Router>
      <ClearStorageOnClose />
      <AuthProvider>
        <LanguageProvider>
          <GlobalTTS />
          <Navbar data-tts="false" />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Gallery" element={<Gallery />} />
            <Route path="/Videos" element={<Videos />} />
            <Route path="/Posts" element={<LatestPosts />} />
            <Route path="/Posts/:id" element={<SinglePost />} />{" "}
            <Route path="/about" element={<About />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/messages" element={<Messages />} />
            <Route path="/userInfo" element={<UserInfo />} />
            <Route path="/createContent" element={<CreateContent />} />
            <Route path="/postReview" element={<PostReview />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/edit-post/:id" element={<EditPost />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/search" element={<Search />} />
            <Route path="/videoReview" element={<VideoReview />} />
            <Route path="/Resources" element={<Resources/>} />
          </Routes>
          <ChatbotBubble />
          <Footer />
        </LanguageProvider>
      </AuthProvider>
    </Router>
  );
}
